import { Row, Col, Spinner, Container } from 'react-bootstrap';
import { NavBar } from "../components/FrontPage/NavBar";
import { Banner } from "../components/FrontPage/Banner";
import { Announcement } from 'components/FrontPage/Announcement';
import { NextMeeting } from "../components/FrontPage/NextMeeting";
import { ForYou } from "../components/FrontPage/ForYou";
import { Info } from '../components/FrontPage/Info';
import { Contact } from '../components/FrontPage/Contact';
import { Footer } from "../components/FrontPage/Footer";
import HomeEditorComponent from "../components/FrontPage/homeEditorComponent";
import headerImg from "../assets/logos/TMLogo.png";

import { useSelector } from "react-redux";
import { useState, useRef, useEffect, useCallback } from "react";

export default function Home() {
    const { user: authUser } = useSelector((state) => state.auth);
    const url = process.env.REACT_APP_URL;

    const [homePageData, setHomePageData] = useState(null);
    const [clubData, setClubData] = useState(null);
    const [isEditorVisible, setIsEditorVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const editorRef = useRef(null);

    const toggleEditor = () => setIsEditorVisible((prev) => !prev);

    const handleClickOutside = (event) => {
        if (editorRef.current && !editorRef.current.contains(event.target)) {
            setIsEditorVisible(false);
        }
    };

    const fetchData = useCallback(async (endpoint, setData) => {
        try {
            const response = await fetch(`${url}/${endpoint}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            if (response.ok) {
                const data = await response.json();
                setData(Array.isArray(data) ? data[0] : data);
            } else {
                console.error(`Error fetching ${endpoint}:`, response.statusText);
            }
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
        }
    }, [url]);

    const getHomePageData = useCallback(() => fetchData("front", setHomePageData), [fetchData]);
    const getClubData = useCallback(() => fetchData("club", setClubData), [fetchData]);

    useEffect(() => {
        const fetchAllData = async () => {
            setIsLoading(true);
            await Promise.all([getHomePageData(), getClubData()]);
            setIsLoading(false);
        };
        fetchAllData();
    }, [getHomePageData, getClubData]);

    useEffect(() => {
        if (isEditorVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isEditorVisible]);

    if (isLoading) {
        return (
            <div className="text-center my-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }
    if (!homePageData || (homePageData.banner.visible === false && homePageData.announcement.visible === false && homePageData.nextMeeting.visible === false && homePageData.forYou.visible === false && homePageData.info.visible === false && homePageData.contact.visible === false)) {
        return (
            <Row>
                <Col xs={12} id="mainpage">
                    <NavBar clubData={clubData} getClub={getClubData} />
                    <section className="banner" id="welcome" style={{ minHeight: "100vh" }}>
                        <Container>
                            <Row className="align-items-center">
                                <Col xs={12} md={6} xl={5} className="mb-60 pe-5" >
                                    <div className="animate__animated animate__zoomIn">
                                        <img src={headerImg} alt="Header Img" />
                                        <h2 className="text-center mt-5">WHERE LEADERS ARE MADE</h2>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} xl={7}>
                                    <div className="animate__animated animate__fadeIn">
                                        <h1 className="animate__animated animate__slideInUp mb-5">
                                            <span className='bold'>WE ARE SORRY!</span>
                                            <br />
                                            <span>For the moment our page is not set up for the public view.</span>
                                        </h1>
                                        {/* <p><br /><br /></p> */}
                                        <p className="border-top-bottom subtitle mb-30 mt-5 animate__animated animate__slideInUp">
                                            Please try again later or contact the club officers to have it set up!<br />
                                            Thank you for your patience!
                                        </p>
                                        {authUser?.user.acl === "Officer" && (
                                            <h5>NOTE: <span className='small'>As an officer, you can edit the front page by clicking the editor (black arrow) button on the top-right side of the screen.</span></h5>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <Footer clubData={clubData} getClub={getClubData} />
                </Col>
                <Col>
                    {authUser?.user.acl === "Officer" && (
                        <button
                            onClick={toggleEditor}
                            style={{
                                position: "fixed",
                                top: "100px",
                                right: isEditorVisible
                                    ? window.innerWidth >= 992
                                        ? "calc(33.333% - 8px)"
                                        : "calc(83.333% - 8px)"
                                    : "-8px",
                                zIndex: 1050,
                                backgroundColor: "black",
                                color: "white",
                                border: "none",
                                padding: "10px",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                            className="toggle-editor-btn"
                        >
                            {isEditorVisible ? (
                                <i className="bi bi-chevron-right"></i>
                            ) : (
                                <i className="bi bi-chevron-left"></i>
                            )}
                        </button>
                    )}
                </Col>
                {authUser?.user.acl === "Officer" && isEditorVisible && (
                    <Col
                        id="editor"
                        xs={10}
                        lg={4}
                        ref={editorRef}
                        className="editor-overlay"
                        style={{
                            position: "fixed",
                            top: 0,
                            right: 0,
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.9)",
                            boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                            overflow: "auto",
                            zIndex: 1040,
                            transition: "width 0.3s ease-in-out",
                        }}
                    >
                        <h4 className="p-3">Front Page Editor</h4>
                        <HomeEditorComponent
                            homePageData={homePageData}
                            getHomePageData={getHomePageData}
                            clubData={clubData}
                            getClub={getClubData}
                        />
                    </Col>
                )}
            </Row>

        );
    }

    return (
        <Row>
            <Col xs={12} id="mainpage">
                <NavBar clubData={clubData} getClub={getClubData} />
                {homePageData?.banner?.visible && (
                    <Banner homePageData={homePageData} refreshHomePageData={getHomePageData} />
                )}
                {homePageData?.announcement?.visible && (
                    <Announcement homePageData={homePageData} refreshHomePageData={getHomePageData} />
                )}
                {homePageData?.nextMeeting?.visible && (
                    <NextMeeting homePageData={homePageData} />
                )}
                {homePageData?.forYou?.visible && (
                    <ForYou homePageData={homePageData} refreshHomePageData={getHomePageData} />
                )}
                {homePageData?.info?.visible && (
                    <Info homePageData={homePageData} refreshHomePageData={getHomePageData} />
                )}
                {homePageData?.contact?.visible && Array.isArray(homePageData.contact.to) && homePageData.contact.to.length > 0 && (
                    <Contact homePageData={homePageData} refreshHomePageData={getHomePageData} />
                )}
                <Footer clubData={clubData} getClub={getClubData} />

                {authUser?.user.acl === "Officer" && (
                    <button
                        onClick={toggleEditor}
                        style={{
                            position: "fixed",
                            top: "100px",
                            right: isEditorVisible
                                ? window.innerWidth >= 992
                                    ? "calc(33.333% - 8px)"
                                    : "calc(83.333% - 8px)"
                                : "-8px",
                            zIndex: 1050,
                            backgroundColor: "black",
                            color: "white",
                            border: "none",
                            padding: "10px",
                            borderRadius: "5px",
                            cursor: "pointer",
                        }}
                        className="toggle-editor-btn"
                    >
                        {isEditorVisible ? (
                            <i className="bi bi-chevron-right"></i>
                        ) : (
                            <i className="bi bi-chevron-left"></i>
                        )}
                    </button>
                )}
            </Col>
            {authUser?.user.acl === "Officer" && isEditorVisible && (
                <Col
                    id="editor"
                    xs={10}
                    lg={4}
                    ref={editorRef}
                    className="editor-overlay"
                    style={{
                        position: "fixed",
                        top: 0,
                        right: 0,
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.9)",
                        boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                        overflow: "auto",
                        zIndex: 1040,
                        transition: "width 0.3s ease-in-out",
                    }}
                >
                    <h4 className="p-3">Front Page Editor</h4>
                    <HomeEditorComponent
                        homePageData={homePageData}
                        getHomePageData={getHomePageData}
                        clubData={clubData}
                        getClub={getClubData}
                    />
                </Col>
            )}
        </Row>
    );
}